import { TableRow, TableCell } from '@mui/material';
import { getNumberComma } from '../../utils/numberUtils';
import SalesManageStaticsTableCell from './SalesManageStaticsTableCell';

const SalesManageStaticsTeamRow = ({ data, headerRows }) => {
  if (!headerRows || !data) {
    return null;
  }

  return (
    data &&
    data.map((hq, hIndex) => {
      return hq?.children.map((dp, dpIndex) => {
        return dp?.children.map((team, tIndex) => (
          <TableRow key={`${hIndex}_${dpIndex}_${tIndex}`}>
            {dpIndex === 0 && tIndex === 0 && (
              <TableCell
                rowSpan={hq.rowSpan}
                sx={{ width: '100px' }}
                colSpan={hq?.id === 'total' ? '3' : '1'}
              >
                {hq.name}
              </TableCell>
            )}
            {tIndex === 0 &&
              hq?.id !== 'total' &&
              dp?.id !== 'total' &&
              team?.id !== 'total' && (
                <TableCell
                  rowSpan={dp.rowSpan}
                  sx={{ width: '200px' }}
                  colSpan={team?.name === dp?.name ? 2 : 1}
                >
                  {dp.name}
                </TableCell>
              )}
            {tIndex === 0 && hq?.id !== 'total' && dp?.id === 'total' && (
              <TableCell
                rowSpan={dp.rowSpan}
                sx={{ width: '200px' }}
                colSpan={team?.name === dp?.name ? 2 : 1}
              >
                {dp.name}
              </TableCell>
            )}
            {team?.name !== dp?.name && (
              <TableCell sx={{ width: '300px' }}>{team.name}</TableCell>
            )}
            <TableCell sx={{ width: '100px' }} align="right" padding="none">
              {getNumberComma(team?.yearBudget)}
            </TableCell>
            <SalesManageStaticsTableCell
              data={team?.data}
              headerRows={headerRows}
            />
          </TableRow>
        ));
      });
    })
  );
};

export default SalesManageStaticsTeamRow;
